import { createUseStyles } from "react-jss";
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import successDialogHeader from '../../../assets/images/successDialogHeader.svg'
import ButtonV2 from "../../atoms/ButtonV2";

interface SuccessDialogProps {
    dialogOpen: boolean;
    setDialogOpen?: (open: boolean) => void;
    title: string,
    content: string,
}

const useStyles = createUseStyles((theme: any) => ({
    container: {
        "& .MuiDialog-paper": {
            height: "398px !important",
            width: "458px !important",
            borderRadius: "24px"
        },
    },
    mainHeading:{
        color: theme.palette.textV2.tertiary.tertiary600
    },
    content:{
        color: theme.palette.textV2.tertiary.tertiary600
    },
    button:{
        paddingLeft: "89px !important",
        paddingRight: "89px !important",
        borderColor:  theme.palette.textV2.tertiary.tertiary800,
        color: theme.palette.textV2.tertiary.tertiary800
    }
}));

const SuccessDialogTemplate: React.FC<SuccessDialogProps> = ({ dialogOpen, setDialogOpen = () => {}, title, content }) => {
    const classes = useStyles();
    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Dialog className={classes.container}
            open={dialogOpen} onClose={handleDialogClose}>
                 <div className={`absolute top-0 right-0 p-4 cursor-pointer`} onClick={handleDialogClose}>
          <CloseIcon />
        </div>
            <div className={` flex gap-x-6 `}>
                <div className="flex flex-col items-center gap-y-6">
                        <img src={successDialogHeader} alt=""/>
                    <div className="flex flex-col items-center gap-y-3 w-4/5">
                        <div className={`${classes.mainHeading} text-4xl font-semibold mx-auto`}>{title}</div>
                        <div className={`${classes.content} grid text-sm text-center`}>
                            {content}
                        </div>
                    </div>
                    <div className="mx-auto mb-6">
                        <ButtonV2 className={`${classes.button}  !text-lg`} variant="tertiaryContained" label="Continue" onClick={handleDialogClose} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default SuccessDialogTemplate;